<template>
	<div class="xl-main">
		<!-- <div id="xl-download">
			<div class="dw_left">
				<div class="dw_left_img"><img src="../images/xl_download_16.png" alt="闲来麻将"></div>
				<div class="dw_left_name"><p class="gname">闲来麻将</p><p class="gsize">{{gsize}}M</p><p class="game_playing">地道家乡玩法</p></div>
			</div>
			<div class="dw_right">
				<a href="https://itunes.apple.com/cn/app/id1309457127?mt=8" class="dw_right_top">
					<div class="dw_right_top_img">
						<img src="../images/xl_download_19.png">
					</div>
					<div class="dw_right_top_dow"><span>App&nbsp; Store</span><span>下载</span></div>
				</a>

				<a :href=this.gameList[0].url class="dw_right_bottom">
					<div class="dw_right_bottom_img">
						<img src="../images/xl_download_21.png">
					</div>
					<div class="dw_right_bottom_dow"><p>安卓下载</p></div>
				</a>
			</div>


		</div> -->
		<div id="xl-mahjong">
			<h2>麻将游戏</h2>
			<h3>文明游戏&nbsp;&nbsp;,&nbsp;&nbsp;禁止赌博</h3>
			<ul >
				<li v-for="(item,index) in gameList" :key="index">
					<a :href=item.url>
						<div class="list_img">
							<img :src=item.gameSrc>
							<div class="show">
								<img :src=item.hot v-show=item.show >
							</div>

						</div>
						<p>{{item.name}}</p>
						<button>下&nbsp;载<img src="../images/xl_game_29.png"></button>
					</a>
				</li>
			</ul>
		</div>
		<!-- <div id="xl-card">
			<h2>赚金系列</h2>
			<h3>文明游戏&nbsp;&nbsp;,&nbsp;&nbsp;禁止赌博</h3>
			<ul >
				<li v-for="(item,index) in cardList" :key="index">
					<a :href=item.url>
						<div class="list_img" style="margin:  0 auto">
							<img :src=item.gameSrc>
							<div class="show">
								<img :src=item.hot v-show=item.show >
							</div>

						</div>
						<p>{{item.name}}</p>
						<button class="card_button">下&nbsp;载<img src="../images/xl_game_29.png"></button>
					</a>
				</li>
			</ul>
		</div> -->
	</div>
</template>
<script type="text/javascript">
  import xlgame from '../images/xl_game_25.png'
  import sichuan from '../images/xl_sichuan.jpg'
  import guangdong from '../images/xl_guangdong.png'
  import shanshanxi from '../images/xl_shanxi.png'
  import guizhou from '../images/xl_guizhou.png'
  import guangxi from '../images/xl_guangxi.png'
  import gansu from '../images/xl_gansu.png'
  import yunnan from '../images/xl_yunnan.png'
  import fujian from '../images/xl_fujian.png'
  import ningxia from '../images/xl_ningxia.png'
  import hainan from '../images/xl_hannan.png'
  import anhui from '../images/xl_anhui.jpg'
  import neimeng from '../images/xl_neimeng.png'
  import shanghai from '../images/xl_shanghai.png'
  import hubei from '../images/xl_hubei.png'
  import ddzfk from '../images/ddzfk.png'

  import doudizhu from '../images/doudizhuzhuanjin.png'
  import majiangzhuanjin from '../images/icon-mjzhuanjin.png'
  import pdkzhuanjin from '../images/pdkzhuanjin.png'
  import paodekuai from '../images/xl_paodekuai.png'
  import paohuzi from '../images/xl_paohuzi.png'
  import chess from '../images/xl_chess.jpg'
  import pandaMahjong from '../images/xl_panda.jpg'
  import hpChess from '../images/xl_hpchess.png'
  import dailyChess from '../images/xl_dychess.png'

  import hot from '../images/hot.png'
  import newPr from '../images/new.png'

  export default{
    data () {
      return {
        gsize:33.04,
        test:"../images/xl_game_25.png",
        gameList:[
          {name:"闲来麻将",gameSrc:xlgame,hot:hot,show:true,url:"http://app6.auwvnd.cn/?downloadfrom=hunan"},
          {name:"熊猫四川麻将",gameSrc:sichuan,hot:hot,show:true,url:"http://app6.auwvnd.cn/?downloadfrom=sichuan"},
          {name:"闲来广东麻将",gameSrc:guangdong,hot:hot,show:true,url:"http://app6.auwvnd.cn/?downloadfrom=guangdong"},
          {name:"闲来陕西麻将",gameSrc:shanshanxi,hot:hot,show:true,url:"http://app6.auwvnd.cn/?downloadfrom=shanxi"},
          {name:"闲来贵州麻将",gameSrc:guizhou,hot:hot,show:true,url:"http://app6.auwvnd.cn/?downloadfrom=guizhou"},
          {name:"闲来广西麻将",gameSrc:guangxi,hot:newPr,show:true,url:"http://app6.auwvnd.cn/?downloadfrom=guangxi"},
          {name:"闲来甘肃麻将",gameSrc:gansu,hot:newPr,show:true,url:"http://app6.auwvnd.cn/?downloadfrom=gansu"},
          {name:"山水云南麻将",gameSrc:yunnan,hot:hot,show:true,url:"http://app6.auwvnd.cn/?downloadfrom=yunnan"},
          {name:"八闽福建麻将",gameSrc:fujian,hot:newPr,show:true,url:"http://app6.auwvnd.cn/?downloadfrom=fujian"},
          {name:"闲来宁夏麻将",gameSrc:ningxia,hot:newPr,show:true,url:"http://app6.auwvnd.cn/?downloadfrom=ningxia"},
          {name:"琼崖海南麻将",gameSrc:hainan,hot:hot,show:true,url:"http://app6.auwvnd.cn/?downloadfrom=hainan"},
          {name:"闲来安徽麻将",gameSrc:anhui,hot:hot,show:true,url:"http://app6.auwvnd.cn/?downloadfrom=anhui"},
          {name:"龙腾内蒙麻将",gameSrc:neimeng,hot:newPr,show:true,url:"http://app6.auwvnd.cn/?downloadfrom=neimeng"}
        ],
        cardList:[
          {name:"闲来斗地主赚金版",gameSrc:doudizhu,hot:hot,show:true,url:"http://app6.auwvnd.cn/?downloadfrom=doudizhuzhuanjin"},
          {name:"闲来麻将赚金版",gameSrc:majiangzhuanjin,hot:hot,show:true,url:"http://app6.auwvnd.cn/?downloadfrom=mjzhuanjin1"},
          {name:"闲来跑得快赚金版",gameSrc:pdkzhuanjin,hot:hot,show:true,url:"http://app6.auwvnd.cn/?downloadfrom=pdkzhuanjin1"}
        ]
      }
    },
    mounted(){

    }
  }
</script>



// WEBPACK FOOTER //
// Main.vue?7a4838db